import { BaseResponseMapper } from './Base'
import { AxiosResponse } from 'axios'
import { UserCMS, AdminCMS } from '@/domain/entities/adminCMS'
import { Pagination } from '@/domain/entities/Pagination'

export class AdminCMSMapper extends BaseResponseMapper {
  public convertAdminCMSMapper(result: AxiosResponse<any>): UserCMS {
    const { data } = result
    return new UserCMS(
      data.success,
      data.message,
      data.data.map(
        (val) =>
          new AdminCMS(
            val.name,
            val.email,
            val.phone,
            val.role_name,
            val.role_id,
            val.need_sales_code,
            val.password,
            val.last_login,
            val.id
          )
      ),
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      )
    )
  }
  public convertRoleCMSMapper(
    result: AxiosResponse<any>
  ): Array<Record<string, number | string>> {
    const { data } = result
    return data.data.map((item) => {
      return {
        value: item.id,
        salescode: item.need_sales_code,
        text: item.role_name,
      }
    })
  }
}
